export default __webpack_public_path__ + "static/media/dawn_s.5d529ea8.jpg";